var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27103 15.6559C10.5345 12.9275 14.7111 11.1288 16.8009 10.2597C22.7677 7.77842 24.0075 7.34739 24.8156 7.33316C24.9934 7.33003 25.3908 7.37407 25.6482 7.58291C25.8656 7.75925 25.9254 7.99746 25.954 8.16465C25.9826 8.33185 26.0182 8.71271 25.9899 9.01031C25.6666 12.407 24.2675 20.65 23.5557 24.4544C23.2545 26.0642 22.6615 26.6039 22.0874 26.6567C20.8397 26.7715 19.8922 25.8323 18.6837 25.0403C16.7927 23.801 15.7244 23.0295 13.8889 21.8201C11.7676 20.4225 13.1427 19.6543 14.3517 18.3989C14.668 18.0704 20.1655 13.071 20.2719 12.6175C20.2852 12.5607 20.2975 12.3493 20.1719 12.2377C20.0463 12.126 19.8608 12.1642 19.727 12.1946C19.5374 12.2376 16.5165 14.2339 10.6643 18.1836C9.80684 18.7722 9.03017 19.0591 8.3343 19.044C7.56715 19.0275 6.09147 18.6104 4.99446 18.2538C3.64893 17.8165 2.57952 17.5853 2.67264 16.8427C2.72115 16.4559 3.25394 16.0603 4.27103 15.6559Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.33e97216.svg";
export { ForwardRef as ReactComponent };